import React from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { RadioGroup, FormControlLabel, Typography, Radio } from '@material-ui/core';
import { RadioButtonUnchecked, RadioButtonChecked } from '@material-ui/icons';

import { DelivererType } from '../../../../../models/DelivererType.enum';
import ManualEntryEdit from '../../../../../models/ManualEntryEdit';

import style from '../manualEntryStyle.module.css';
import commonStyles from '../../../../common/common.module.css';
import ManualEntryAdd from '../../../../../models/ManualEntryAdd';

const styles = (theme: Theme) =>

  createStyles({
    formControlLabel: {
      marginRight: '2%',
      '& p': {
        fontSize: '14px'
      }
    },
    label: {
      color: 'var(--primaryblue)'
    }
  });

interface DelivererTypeComponentProps {
  classes: any;
  delivererType: string;
  handleChangeDelivererType: (event: any) => void;
  type: string;
  manualEntryEdit: ManualEntryEdit;
  manualEntryAdd: ManualEntryAdd;
};

const delivererTypeComponent = (props: DelivererTypeComponentProps) => {

  const { classes } = props;
  const forwarderRadioLabel = props.type === 'go' ? 'GO Warehouse' : 'Forwarder';
  const forwarderRadio: JSX.Element = <FormControlLabel
                                        key={ 'fwdKey' }
                                        value={ props.type === 'go' ? 'go' : DelivererType.FORWARDER }
                                        className={ classes.formControlLabel }
                                        control={
                                          < Radio 
                                            icon={ <RadioButtonUnchecked color='primary' /> }
                                            checkedIcon={ <RadioButtonChecked color='primary' /> }
                                          /> 
                                        } 
                                        label={<Typography className={ classes.label }> {forwarderRadioLabel}</Typography>}
                                      />;
  const rfsRadio: JSX.Element = <FormControlLabel
                                  key={ 'rfsKey' }
                                  value={ DelivererType.RFS }
                                  className={ props.classes.formControlLabel }
                                  control={
                                    < Radio 
                                      icon={ <RadioButtonUnchecked color='primary' /> }
                                      checkedIcon={ <RadioButtonChecked color='primary' /> }
                                    /> 
                                  } 
                                  label={<Typography className={ props.classes.label }> RFS</Typography>}
                                />;
  const interlineRadio: JSX.Element = <FormControlLabel
                                        key={ 'intLineKey' }
                                        value={ DelivererType.INTERLINE }
                                        className={ props.classes.formControlLabel }
                                        control={
                                          < Radio 
                                            icon={ <RadioButtonUnchecked color='primary' /> }
                                            checkedIcon={ <RadioButtonChecked color='primary' /> }
                                          /> 
                                        } 
                                        label={<Typography className={ props.classes.label }> Interline Transfer</Typography>}
                                      />;
  const interlineRadioRender: JSX.Element | null = props.type === 'do' ? interlineRadio : null;
  const rfsRadioRender: JSX.Element | null = props.type === 'do' ? rfsRadio : null;

  return (
    <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
      <h3 className={ `${ commonStyles.header }` } >{ props.type === 'po' || props.type === 'go' ? 'Pick Up By' : 'Drop Off By' }</h3>
      <div className={ style.inputsWrapper } >
        <RadioGroup
          name="delivererType"
          value={ props.delivererType }
          row={ true }
          onChange={  props.handleChangeDelivererType } 
          className={ `${ classes.radioGroup } ${ style.driverInfoWrapper }`}
        >
          { !props.manualEntryEdit.isEditMode && !props.manualEntryAdd.isAddMode &&
            [
              (forwarderRadio),
              (interlineRadioRender),
              (rfsRadioRender)
            ]
          }
          {( props.manualEntryEdit.isEditMode || props.manualEntryAdd.isAddMode) &&
            <FormControlLabel 
              value={ props.delivererType }
              className={ props.classes.formControlLabel }
              control={
                < Radio 
                  icon={ <RadioButtonUnchecked color='primary' /> }
                  checkedIcon={ <RadioButtonChecked color='primary' /> }
                /> 
              } 
              label={<Typography className={ props.classes.label }>{ (props.delivererType === DelivererType.FORWARDER || props.delivererType === 'go') ? (props.type === 'go' ? 'GO Warehouse' : 'Forwarder') :  props.delivererType === DelivererType.RFS ? 'RFS'  : 'Interline Transfer'}</Typography>}
            />
          }
        </RadioGroup>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    manualEntryEdit: state.manualEntryEdit,
    manualEntryAdd: state.manualEntryAdd
  };
}
  
export default withStyles(styles)(connect(mapStateToProps, {})(delivererTypeComponent));
